import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/logo.svg";
import { Link } from "react-scroll";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
/*import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";*/


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const LinkTw = tw(Link)`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4 cursor-pointer`;

const Contacts = tw.div`mt-2 text-center text-sm`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;
const Svg = styled.div`
  ${tw`bg-white`}
  -webkit-mask: url(${props => props.image}) no-repeat center;
  mask: url(${props => props.image}) no-repeat center;
  height: 80px; width: 210px;
  mask-size: cover;`;
const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <Svg image={logo} />
          </LogoContainer>
          <LinksContainer>
            <LinkTw to="sobre" spy={true} smooth={true} offset={-70} duration={500}>Sobre</LinkTw>
            <LinkTw to="contacto" spy={true} smooth={true} offset={-70} duration={500}>Contacto</LinkTw>
            <LinkTw to="escritorios" spy={true} smooth={true} offset={-70} duration={500}>Escritórios</LinkTw>
            <LinkTw to="contacto" spy={true} smooth={true} offset={-70} duration={500}>Orçamentos</LinkTw>
          </LinksContainer>
          <Contacts>
            Centro Comercial Flor do Dão, Loja V <br/>
            Av. General Humberto Delgado <br/>
            3440–325 Santa Comba Dão <br/>
            <br/>
            Email: geral@condofraccoes.pt <br/>
            Tlf.: 232888100 / Seg. Ter. Qui
          </Contacts>
          <SocialLinksContainer>
            <SocialLink href="https://www.facebook.com/p/CondoFrac%C3%A7%C3%B5es-Administra%C3%A7%C3%A3o-Condom%C3%ADnios-100027309412739/">
              <FacebookIcon />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            &copy; Copyright 2024, CondoFracções. Todos os direitos reservados.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
